<template>
  <div class="i-main-content">

    <!--面包屑-->
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/' }">Home</el-breadcrumb-item>
      <el-breadcrumb-item>Device List</el-breadcrumb-item>
    </el-breadcrumb>

    <!--搜索-->
    <search-wrapper>
      <tree-select :datas="treeSelect.data" v-model="treeSelect.visible" class="block"  v-show="loginInfo.UserType == 0"
        :defaultCheckedRows="treeSelect.checked" @check="treeSelectCheck" :panel-width="treeSelect.width"
        :props="treeSelect.props" check-strictly expand-first show-check-all>
        <el-input v-model="treeSelect.text" placeholder="Select Enterprise" slot="active" @focus="treeSelect.visible=true" readonly></el-input>
      </tree-select>
      <!--查询字段选项-->
      <el-select v-model="searchFieldName" placeholder="Query Type" class="block">
        <el-option
          v-for="item in searchFieldOptions"
          :key="item.value"
          :label="item.label"
          :value="item.value">
        </el-option>
      </el-select>
      <!--查询字段内容-->
      <el-input v-model="searchText" placeholder="Query Text" prefix-icon="el-icon-search" class="block" clearable></el-input>
      <el-button @click="queryHandle" type="primary" :disabled="tableLoading">Query</el-button>
      <space></space>
      <el-button @click="addHandle" type=""  v-if="hasFun(3005)">Add</el-button>
      <el-button @click="deleteHandle" type=""  v-if="hasFun(3015)" :loading="deleteButtonLoading">Delete</el-button>
    </search-wrapper>

    <!--表格-->
    <el-table ref="multipleTable" :data="tableData" tooltip-effect="dark" tyle="width: 100%"
      @selection-change="val => multipleSelection=val" v-loading="tableLoading">
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column label="Name" prop="DeviceName" width="150" show-overflow-tooltip></el-table-column>
      <el-table-column label="Device ID" width="150">
        <div class="i-link" slot-scope="scope" @click.stop="rowClick(scope.row)">{{ scope.row.DeviceID }}</div>
      </el-table-column>
      <el-table-column label="EnterPrise" prop="Enterprise1" width="150" show-overflow-tooltip></el-table-column>
      <el-table-column label="Module-IMEI" prop="ModuleIMEI" width="150" :formatter="emptyFormat">
      </el-table-column>
      <el-table-column label="Module-SN" prop="ModuleSN" width="130" :formatter="emptyFormat">
      </el-table-column>
      <el-table-column label="SIM-ICCID" prop="SIMICCID" width="170" :formatter="emptyFormat"></el-table-column>
      <el-table-column label="SIM-IMEI" prop="SIMIMEI" width="150" :formatter="emptyFormat"></el-table-column>
      <el-table-column label="Status" width="120" :formatter="emptyFormat">
        <template slot-scope="scope">
          <el-tag :type="scope.row.Status == 0 ? 'info' : 'success'">{{scope.row.Status == 0 ? 'Offline' : 'Online'}}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="RcvTime" label="RcvTime" :formatter="emptyFormat" show-overflow-tooltip></el-table-column>
    </el-table>
    <el-pagination class="i-main-pager imt-2" background layout="total, prev, pager, next, jumper" :total="pageTotalCount"
      @current-change="pageCurrentChange"></el-pagination>

    <!--Dialog-->
    <el-dialog title="Info" :visible.sync="dialogVisible" @close="dislogClosed">
      <el-form :model="form" :rules="rules" ref="NewForm" label-position="left" label-width="120px">
        <el-form-item label="Device ID" prop="DeviceID">
          <el-input v-model="form.DeviceID" auto-complete="off" :disabled="!form.newLine"></el-input>
        </el-form-item>
        <el-form-item label="Name" prop="DeviceName">
          <el-input v-model="form.DeviceName" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="Enterprise" prop="EID">
          <tree-select :datas="eidSelect.data" v-model="eidSelect.visible" class="block" :loading="eidSelect.loading"
            :defaultCheckedRows="eidSelect.checked" @check="eidSelectCheck" :props="eidSelect.props"
            :panel-height="200" show-check-all single-check>
            <el-input v-model="eidSelect.text" placeholder="Select Enterprise" slot="active" @focus="eidSelect.visible=true" :disabled="!!form.UserID" readonly></el-input>
          </tree-select>
        </el-form-item>
        <el-form-item label="Module-IMEI">
          <el-input v-model="form.ModuleIMEI" auto-complete="off" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="Module-SN" >
          <el-input v-model="form.ModuleSN" auto-complete="off" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="SIM-ICCID">
          <el-input v-model="form.SIMICCID" auto-complete="off" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="SIM-IMEI">
          <el-input v-model="form.SIMIMEI" auto-complete="off" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="Status">
          <el-input v-model="form.Status" auto-complete="off" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="RcvTime">
          <el-input v-model="form.RcvTime" auto-complete="off" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="okHandle"  v-if="(form.newLine && hasFun(3005)) || (!form.newLine &&hasFun(3010))" :loading="dialogOkButtonLoading">OK</el-button>
          <el-button  v-if="(form.newLine && hasFun(3005)) || (!form.newLine &&hasFun(3010))" @click="dialogVisible = false">Cancel</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
//import {getToken} from '@/common/auth'
import treeSelect from '@/views/mixins/tree-select'
import eidSelect from '@/views/mixins/eid-select'
import searchCommon from '@/views/mixins/search-common'
import searchWrapper from '@/components/search-wrapper'
import {deleteFromArray} from '@/common/utils'
import {mapGetters} from 'vuex'
import {Filter, Op} from '@/api/config'
import * as API from '@/api/device'
import { searchFieldOptions, searchFieldOperation } from './options'
import tableColumnFormat from '@/views/mixins/table-column-format'

export default {
  name: 'company',
  data() {
      return {
        // Dialog
        // clickedRow: {},
        dialogVisible: false,
        form: {},

        // Search
        searchFieldName: '', // 查找字段名
        searchFieldOptions, // 查找备选项
        searchFieldOperation, // 查找字段对应操作
        searchText: '',
        searchCompany: '',

        // Table
        tableData: [],

        multipleSelection: [], // 选中行数据

        // 验证规则
        rules: {
          DeviceID: [
            { required: true, trigger: 'blur' },
            { min: 3, max: 15, trigger: 'blur' }
          ],
          DeviceName: [
            { required: true, trigger: 'blur' },
            { min: 3, max: 50, trigger: 'blur' }
          ],
          EID: [
            { required: true,message: 'Enterprise is required',trigger: 'change' }
          ]
        }
      }
  },
  computed: {
    ...mapGetters([
      'userId',
      'loginInfo'
    ])
  },
  created() {
    this.queryHandle()
  },
  methods: {
    // 表格行点击事件
    rowClick(row) {
      //console.log(this, Object.keys(this.clickedRow), Object.keys(row))

      // Object.keys(row).forEach(item => {
      //   this.$set(this.form, item, row[item])
      // })
      this.form = Object.assign({}, row)
      this.eidSelectSetChecked(row.EID)
      this.dialogVisible = true
    },

    // 新增事件
    addHandle() {
      // Object.keys(this.form).forEach(item => {
      //   this.form[item] = null
      // })
      this.form = {newLine: true}
      this.eidSelectSetChecked(null)
      this.dialogVisible = true
    },

    // 删除事件
    deleteHandle() {
      const targetRows = this.$refs.multipleTable.selection

      if (targetRows.length <= 0) {
        this.$alert('You must select at least one item.', '', {
          type: 'error'
        })
        return
      }

      this.$confirm('This item will be permanently deleted ?', 'Warning', {
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {

        this.deleteButtonLoading = true
        API.Delete(targetRows.map(k => k.DeviceID)).then(ret => {

          // // 从本地删除
          // targetRows.forEach(item => {
          //   deleteFromArray(this.tableData, row => {
          //     return row == item
          //   })
          // })

          this.$message({
            type: 'success',
            message: 'Success!',
            showClose: true
          });

          if ((targetRows.length < this.pageSize)
            && (targetRows.length < this.tableData.length)) {
            this.pageIndex = this.pageIndex > 1 ? this.pageIndex - 1 : 1
          }
          this.queryHandle()

          this.deleteButtonLoading = false

        }).catch(err => {
          this.print('error', err.message)
          this.deleteButtonLoading = false
        })

      }).catch(() => {

      });
    },

    // 弹出框验证
    okHandleValidate() {
      const promise = new Promise((resolve, reject) => {
        this.$refs.NewForm.validate(valid => {
          if (valid) {
            resolve(true)
          } else {
            reject(false)
          }
        })
      })

      return promise
    },

    // 弹出页确认事件
    async okHandle() {
      // const index = this.tableData.findIndex(item => {
      //   return item.DeviceID == this.form.DeviceID
      // })
      let valid
      try {
        valid = await this.okHandleValidate()
      } catch (e) {
        valid = false
      }

      if (!valid) {
        return
      }

      if (this.form.newLine) {
        // Add
        API.Add(this.eidSelect.checked[0].EID,
          this.form.DeviceID,
          this.form.DeviceName).then(ret => {

            if (!ret.data.errCode) {
              this.queryHandle().then(() => {
                this.dialogVisible = false
                this.dialogOkButtonLoading = false
              }).catch(() => {
                this.dialogVisible = false
                this.dialogOkButtonLoading = false
              })
            } else {
              // 错误
              this.print('error', ret.data.errMsg)
            }

        }).catch(err => {
          // 错误
          this.print('error', err.message)
        })
      } else {
        // Modify
        API.Modify(
          this.form.DeviceID,
          this.eidSelect.checked[0].EID,
          this.form.DeviceName).then(ret => {

            if (!ret.data.errCode) {
              this.queryHandle().then(() => {
                this.dialogVisible = false
                this.dialogOkButtonLoading = false
              }).catch(() => {
                this.dialogVisible = false
                this.dialogOkButtonLoading = false
              })
            } else {
              // 错误
              this.print('error', ret.data.errMsg)
            }

        }).catch(err => {
          // 错误
          this.print('error', err.message)
        })
      }

      this.dialogVisible = false
    },

    // 查询事件
    queryHandle() {
      const promise = new Promise((resolve, reject) => {
        const filters = []
        this.searchText.length > 0
          && (filters.push(new Filter(this.searchFieldName, this.searchText, Op.Contains)))
        this.treeSelect.checked.length > 0
          && (filters.push(new Filter("EID", this.treeSelect.checked.map(k => {
            return parseInt(k.EID)
          }),
          Op.IListContains)))

        this.tableLoading = true

        API.Query(this.pageIndex, this.pageSize, this.sortKey, this.sortDirect, filters).then(ret => {
          this.tableData = ret.data.list.slice()
          this.pageTotalCount = ret.data.total
          this.tableLoading = false
          resolve()
        }).catch(err => {
          this.print('error', err.message)
          this.tableLoading = false
          reject(err)
        })
      })

      return promise
    },
    // 反选表格
    toggleSelection(rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },

    dislogClosed() {
      this.$refs.NewForm && this.$refs.NewForm.clearValidate()
    }
  },
  components: {
    searchWrapper
  },
  mixins: [treeSelect, searchCommon, eidSelect, tableColumnFormat]
}
</script>

<style lang="scss" scoped>
.i-main-content {
  & .el-form {
    width: 460px;
    margin: 0 auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/device/device.vue